import { HttpResponse, http } from 'msw';
import { API, BASE_URL_V3 } from '../../../src/common/constants';
import { chargePointData5Metadata, chargePointData6Metadata } from '../data/chargePointDataMock';

const URL = `${BASE_URL_V3}${API.endpoints.chargingStations}${API.endpoints.metadata}`;

export const fetchChargingStationsCluster = http.post(URL, async () => {
    return HttpResponse.json(clusterMockResponse);
});

export const mockedClusterEmptyResponse = http.post(URL, async () => {
    return HttpResponse.json({
        hasMore: false,
        chargingStations: [],
    });
});

const clusterMockResponse = {
    hasMore: false,
    chargingStations: [chargePointData5Metadata, chargePointData6Metadata],
};
